import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { InsertTemplateScreensMutation, InsertTemplateScreensMutationVariables } from '@/graphql/generated/graphql';
import { InsertTemplateScreensDocument } from '@/graphql/generated/graphql';
export type TemplateScreenInsertInput = {
  OrganizationIds?: string[]
  TemplateId?: string
  Title?: string
  Description?: string
  Order?: number
  Type?: string
  AiPrompt?: string
  AiOutputSchema?: string
  DynamicMaxFields?: number
  DynamicPrompt?: string
  SignatoryConfig?: string
  UilmDescriptionKey?: string
  UilmTitleKey?: string
  EnableApplyStandards?: boolean
  Conditions?: string
}

export type InsertTemplateScreenResponse = {
  data: {
    insertTemplateScreens: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useInsertTemplateScreen = () => {
  const mutation = useMutation({
    mutationKey: ['insert-template-screen'],
    mutationFn: (variables: TemplateScreenInsertInput) => {
      return graphqlClient.request<InsertTemplateScreensMutation>(InsertTemplateScreensDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    insertTemplateScreen: mutation.mutate,
    insertTemplateScreenAsync: mutation.mutateAsync,
  }
}

export const INSERT_TEMPLATE_SCREEN_MUTATION = InsertTemplateScreensDocument;
